import React from 'react';
import _TopBusinessTab from './_TopBusinessTab.scss';
import {TopBusinessList} from './TopBusiness';
import {withRouter} from 'react-router-dom';

class TopBusinessTab extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="highlight-needoffer-tab">
        <TopBusinessList/>
      </section>
    );
  }
}

export default withRouter(TopBusinessTab);



// WEBPACK FOOTER //
// ./components/home/sub-view/TopBusinessTab.jsx